"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var extras_exports = {};
__export(extras_exports, {
  AESEncryptionKey: () => import_crypto.AESEncryptionKey,
  AESSealedData: () => import_crypto.AESSealedData,
  Auth: () => import_auth.Auth,
  Barometer: () => import_barometer.Barometer,
  Battery: () => import_battery.Battery,
  Brightness: () => import_brightness.Brightness,
  Browser: () => import_browser.Browser,
  Clipboard: () => import_clipboard.Clipboard,
  Color: () => import_color.Color,
  Crypto: () => import_crypto.Crypto,
  Fonts: () => import_fonts.Fonts,
  LightSensor: () => import_light_sensor.LightSensor,
  Localization: () => import_localization.Localization,
  MenuAction: () => import_menu.MenuAction,
  Network: () => import_network.Network,
  Pedometer: () => import_pedometer.Pedometer,
  SecureStore: () => import_secure_store.SecureStore,
  Speech: () => import_speech.Speech,
  SpeechSynthesis: () => import_speech_synthesis.SpeechSynthesis,
  SplitView: () => import_split_view.SplitView,
  ToolbarHost: () => import_toolbar.ToolbarHost,
  ToolbarItem: () => import_toolbar.ToolbarItem,
  Updates: () => import_updates.Updates,
  ZoomTransitionAlignmentRectDetector: () => import_zoom.ZoomTransitionAlignmentRectDetector,
  ZoomTransitionEnabler: () => import_zoom.ZoomTransitionEnabler,
  ZoomTransitionSource: () => import_zoom.ZoomTransitionSource,
  useAudioPlayer: () => import_hooks.useAudioPlayer,
  useAudioPlayerStatus: () => import_hooks.useAudioPlayerStatus,
  useBatteryLevel: () => import_battery.useBatteryLevel,
  useBatteryState: () => import_battery.useBatteryState,
  useCalendars: () => import_localization.useCalendars,
  useFonts: () => import_fonts.useFonts,
  useLocales: () => import_localization.useLocales,
  useLowPowerMode: () => import_battery.useLowPowerMode,
  useNetworkState: () => import_network.useNetworkState,
  usePowerState: () => import_battery.usePowerState
});
module.exports = __toCommonJS(extras_exports);
var import_color = require("./color");
var import_fonts = require("./fonts");
var import_zoom = require("./zoom");
var import_toolbar = require("./toolbar");
var import_menu = require("./menu/index");
var import_split_view = require("./split-view");
var import_clipboard = require("./clipboard");
var import_battery = require("./battery");
var import_hooks = require("./audio/hooks");
var import_barometer = require("./barometer");
var import_pedometer = require("./pedometer");
var import_light_sensor = require("./light-sensor");
var import_brightness = require("./brightness");
var import_speech_synthesis = require("./speech-synthesis");
var import_browser = require("./browser");
var import_updates = require("./updates");
var import_network = require("./network");
var import_crypto = require("./crypto");
var import_localization = require("./localization");
var import_secure_store = require("./secure-store");
var import_auth = require("./auth");
var import_speech = require("./speech");
//# sourceMappingURL=extras.js.map
